<template>
    <div>
        <h2 class="text-28 lg:text-36 text-navy font-bold mt-10 mb-2" id="pricing">Pricing</h2>
        <div v-if="data.pricingOption2 && !data.pricingOption1 && !data.pricingOption3"
            class="flex w-full justify-center">
            <div class="w-full md:w-2/5 bg-white shadow tr-box">
                <div class="flex flex-col items-center">
                    <div class="flex flex-col md:flex-row justify-center gap-y-2 md:gap-x-4 items-center p-6">
                        <div class="bg-navy text-white rounded-md py-1.5 px-3 text-28 lg:text-32 font-bold whitespace-nowrap">
                            {{ data.pricingOption2.price }}
                        </div>
                        <div class="text-navy rounded line-through font-bold whitespace-nowrap">
                            {{ data.pricingOption2.strikethrough }}
                        </div>
                    </div>
                    <div v-if="data.pricingOption2.bullets" class="w-full py-4 px-6 pb-8">
                        <ul class="tr-bullets ml-4 flex flex-col gap-y-2">
                            <li v-for="bullet in data.pricingOption2.bullets">{{ bullet }}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="flex flex-col justify-between gap-y-8 items-center lg:flex-row lg:gap-x-8 mt-4">
            <div class="flex-1 w-5/6 lg:w-auto mx-16 lg:mx-0 bg-white shadow rounded-md" v-if="data.pricingOption1"
                 :class="{
                    'border border-navy': selected == 'option1',
                    'border border-gray-300 bg-gray-50': selected != 'option1'
                }"
            >
                <div class="text-navy text-28 lg:text-32 font-bold p-4 text-center">{{ data.pricingOption1.title }}</div>
                <div class="flex flex-col items-center pb-6 border-t border-gray-400">
                    <div class="flex flex-col md:flex-row justify-center gap-y-2 md:gap-x-4 items-center p-4">
                        <div class="bg-navy text-white rounded-md py-1.5 px-3 text-28 lg:text-32 font-bold whitespace-nowrap">{{ data.pricingOption1.price }}</div>
                        <div class="text-navy rounded line-through font-bold whitespace-nowrap">{{ data.pricingOption1.strikethrough }}</div>
                    </div>
                    <div class="w-full py-4 px-6">
                        <ul class="tr-bullets ml-4 flex flex-col gap-y-2">
                            <li v-for="bullet in data.pricingOption1.bullets">{{ bullet }}</li>
                        </ul>
                    </div>
                    <button class=" text-white uppercase font-bold mt-4 py-2 px-4 rounded-md text-xl"
                            :class="{
                                'bg-navy': selected == 'option1',
                                'bg-orange hover:bg-orange-light': selected != 'option1'
                            }"
                            @click="selected = 'option1'"
                    >
                        {{ selected == 'option1' ? 'Selected' : 'Select plan'}}
                    </button>
                </div>
            </div>

            <!-- different styling than Pricing option 1 & 3-->
            <div class="relative overflow-hidden flex-1 w-full lg:w-auto bg-white shadow rounded-md"
                 style="flex-basis: 5%"
                 :class="{
                     'border border-navy': selected == 'option2',
                     'border border-gray-300 bg-gray-50': selected != 'option2'
                 }"
            >
                <div class="bg-navy text-white absolute text-md font-semibold uppercase" style="inset: 0 0 auto auto; transform-origin: 0 0; transform: translate(29.3%) rotate(45deg); box-shadow: 0 0 0 999px #0d2e52; clip-path: inset(0 -100%);">
                    Recommended
                </div>
                <div class="text-navy text-28 lg:text-36 font-bold p-6 text-center">{{ data.pricingOption2.title }}</div>
                <div class="flex flex-col items-center pb-8 border-t border-gray-400">
                    <div class="flex flex-col md:flex-row justify-center gap-y-2 md:gap-x-4 items-center p-6">
                        <div class="bg-navy text-white rounded-md py-1.5 px-3 text-28 lg:text-32 font-bold whitespace-nowrap">{{ data.pricingOption2.price }}</div>
                        <div class="text-navy rounded line-through font-bold whitespace-nowrap">{{ data.pricingOption2.strikethrough }}</div>
                    </div>
                    <div class="w-full py-4 px-6">
                        <ul class="tr-bullets ml-4 flex flex-col gap-y-2">
                            <li v-for="bullet in data.pricingOption2.bullets">{{ bullet }}</li>
                        </ul>
                    </div>
                    <button class=" text-white uppercase font-bold mt-4 py-2 px-4 rounded-md text-xl"
                            :class="{
                                'bg-navy': selected == 'option2',
                                'bg-orange hover:bg-orange-light': selected != 'option2'
                            }"
                            @click="selected = 'option2'"
                    >
                        {{ selected == 'option2' ? 'Selected' : 'Select plan'}}
                    </button>
                </div>
            </div>

            <div v-if="data.pricingOption3" class="flex-1 w-5/6 lg:w-auto mx-16 lg:mx-0 bg-white shadow"
                 :class="{
                     'border border-navy': selected == 'option3',
                     'border border-gray-300 bg-gray-50': selected != 'option3'
                 }"
            >
                <div class="text-navy text-28 lg:text-32 font-bold p-4 text-center">{{ data.pricingOption3.title }}</div>
                <div class="flex flex-col items-center pb-6 border-t border-gray-400">
                    <div class="flex flex-col md:flex-row justify-center gap-y-2 md:gap-x-4 items-center p-4">
                        <div class="bg-navy text-white rounded-md py-1.5 px-3 text-28 lg:text-32 font-bold whitespace-nowrap">{{ data.pricingOption3.price }}</div>
                        <div class="text-navy rounded line-through font-bold whitespace-nowrap">{{ data.pricingOption3.strikethrough }}</div>
                    </div>
                    <div class="w-full py-4 px-6">
                        <ul class="tr-bullets ml-4 flex flex-col gap-y-2">
                            <li v-for="bullet in data.pricingOption3.bullets">{{ bullet }}</li>
                        </ul>
                    </div>
                    <button class=" text-white uppercase font-bold mt-4 py-2 px-4 rounded-md text-xl"
                            :class="{
                                'bg-navy': selected == 'option3',
                                'bg-orange hover:bg-orange-light': selected != 'option3'
                            }"
                            @click="selected = 'option3'"
                    >
                        {{ selected == 'option3' ? 'Selected' : 'Select plan'}}
                    </button>
                </div>
            </div>
        </div>

        <h2 class="text-28 lg:text-36 text-navy font-bold mt-10 mb-2" id="terms">
            TruckersReport LLC Sales Agreement
        </h2>

        <div class="bg-white shadow p-6 tr-box flex flex-col gap-4">
            <div class="flex flex-col gap-4" v-html="agreement"></div>

            <form class="mt-4 flex flex-col gap-2" method="post" @submit.prevent="submit">
                <div>
                    <div class="text-base text-gray-500">Your Name</div>
                    <input class="text-xl px-4 py-2 outline border border-navy rounded-md" type="text" name="name"
                           required v-model="name"
                    >
                </div>
                <div>
                    <div class="text-base text-gray-500">Your Title</div>
                    <input class="text-xl px-4 py-2 outline border border-navy rounded-md" type="text" name="title"
                           required v-model="title">
                </div>
                <div>
                    <label class="cursor-pointer">
                        <input type="checkbox" name="agreed" required>
                        I agree to Truckersreport Terms and Conditions
                    </label>
                </div>
                <div class="mt-2">
                    <button class="cursor-pointer bg-navy text-lg px-4 py-2 text-white rounded-md">
                        <i v-if="loading" class="fa fa-fw fa-spinner fa-spin"></i>
                        {{ text }}
                    </button>
                </div>
            </form>
        </div>

    </div>

</template>

<script>
export default {
    props: [
        'identifier',
        'data'
    ],
    data() {
        return {
            name: '',
            title: '',
            loading: false,
            text: 'Sign Sales Agreement',
            pusher: {
                public: null,
            },
            selected: 'option2'
        }
    },
    computed: {
        agreement() {
            let value = this.data.pricingOption2.price;
            if (this.selected == 'option1') value = this.data.pricingOption1.price;
            if (this.selected == 'option3') value = this.data.pricingOption3.price;
            return this.data.agreement.replace('%amount%', value);
        }
    },
    methods: {
        submit() {
            this.loading = true;
            this.text = 'Signing';

            this.sign();
        },
        sign() {
            axios.post(url(`proposal/${this.identifier}/sign`), {
                name: this.name,
                title: this.title,
                agreed: true,
                option: this.selected
            }).catch(() => {
                window.location.href = url(`proposal/${this.identifier}`);
            });
        }
    },
    created() {
        this.pusher.public = Echo.channel(`public`);
        this.pusher.public.listen('.portal-ready', (event) => {
            if (event.identifier == this.identifier) {
                this.loading = false;
                this.text = 'Signed';
                window.location.href = event.redirect_url;
            }
        });
    },
    beforeDestroy() {
        this.pusher.public.stopListening('.portal-ready');
    }
}
</script>